import type { Stance } from '../types';

const STANCE_COPY: Record<Stance, { label: string; tone: string }> = {
  assert:     { label: 'assert',     tone: 'tone-assert' },
  hedge:      { label: 'hedge',      tone: 'tone-hedge' },
  deny:       { label: 'deny',       tone: 'tone-deny' },
  withdraw:   { label: 'withdraw',   tone: 'tone-withdraw' },
  cite:       { label: 'cite',       tone: 'tone-cite' },
  speculate:  { label: 'speculate',  tone: 'tone-speculate' },
  rhetorical: { label: 'rhetorical', tone: 'tone-rhetorical' },
};

export function StanceBadge({ stance, confidence }: { stance: Stance; confidence?: number }) {
  const meta = STANCE_COPY[stance];
  return (
    <span className={`badge ${meta.tone}`}>
      {meta.label}
      {confidence !== undefined ? ` ${Math.round(confidence * 100)}%` : ''}
    </span>
  );
}
